export enum AdInsightsSidenavStates {
  InfluencedList = 'InfluencedList',
  InfluencedDetails = 'InfluencedDetails',
  AddToAccountList = 'AddToAccountList',
}
